/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Section_PeopleInputs */



/**
* | output |
* | --- |
* | "People" |
*
* @param {Team_Share_Section_PeopleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_section_people = /** @type {((inputs?: Team_Share_Section_PeopleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Section_PeopleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("People")
	if (locale === "de") return /** @type {LocalizedString} */ ("People")
	if (locale === "it") return /** @type {LocalizedString} */ ("People")
	if (locale === "ru") return /** @type {LocalizedString} */ ("People")
	if (locale === "es") return /** @type {LocalizedString} */ ("People")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("People")
	if (locale === "ja") return /** @type {LocalizedString} */ ("People")
	if (locale === "hi") return /** @type {LocalizedString} */ ("People")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("People")
	return /** @type {LocalizedString} */ ("People")
});